export default __webpack_public_path__ + "static/media/manager.545ef760.svg";